module.exports = __webpack_public_path__ + "img/vashe_zdor.c9dd0361.jpg";